import login from './login'
import register from './register'
import resetPassword from './resetPassword'

export default {
  login,
  register,
  resetPassword
}
